const upgradePlanStyles = {
  toggleButton: {
    p: 1,
    cursor: "pointer",
    borderRadius: "5px",
    backgroundColor: "#F5F5F5",
  },
  activeButton: {
    backgroundColor: "#7551D0",
    color: "#FFFFFF",
  },
  planPriceBox: {
    backgroundColor: "#F4F1FC",
    p: 2.5,
    display: "flex",
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    justifyContent: "space-between",
  },
  planPrice: {
    fontSize: "24px !important",
    lineHeight: "0.9 !important",
    fontWeight: 700,
  },
  planName: {
    fontSize: "22px !important",
    lineHeight: "0.9 !important",
    fontWeight: 700,
  },
  planPriceText: {
    display: "flex",
    alignItems: "flex-end",
    textTransform: "none",
  },
};

export default upgradePlanStyles;
